import { useState } from "react";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { Modal } from "react-bootstrap";
import translateText, {
  LanguageDirection,
  currentLanguage,
} from "../signals/language.signal";
import { primary, primaryFount, secondary } from "../signals/Theme colors.signal";
import {
  fetchOrderDetailsApi,
  OrderDetailsData,
  searchOrderData,
} from "../signals/orderData.signal";

const SearchOrderCard = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  
  const fetchDataDetail = async (order) => {
    OrderDetailsData.value = [];
    try {
      const result = await fetchOrderDetailsApi(
        order.TYPE,
        order.SOCCODE,
        "01",
        order.INVTYPE,
        order.INVNO,
        order.INVDATE
      );
      OrderDetailsData.value = result;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleShow = (order) => {
    setSelectedOrder(order);
    fetchDataDetail(order);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  return (
    <>
      {searchOrderData.value ? (
        searchOrderData.value.map((data) => (
          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            key={data.INVNO}
            className="align-items-sm-center d-flex justify-content-center w-100 p-3"
          >
            <div className="loginContaner bg-white p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
              <div className="mb-1 p-3 border w-100   rounded-3 " style={{background: secondary.value}}>
                <div className="w-100 d-flex">
                  <ReceiptLongIcon
                    style={{ fontSize: "40px", marginRight: "10px" }}
                  />
                  <div className=" w-100">
                    <p className="m-0 " style={{ fontSize: "9px" }}>
                      {translateText(currentLanguage.value, "OrderNumber")}
                    </p>
                    <p
                      className="form-label m-0 textColor"
                      style={{ fontSize: "20px" }}
                    >
                      {data.INVNO}
                    </p>
                  </div>
                  {/* <div className=" w-100 text-end">
                    <p className="m-0 " style={{ fontSize: "9px" }}>
                      {translateText(currentLanguage.value, "OrderDate")}
                    </p>
                    <p
                      className="form-label m-0 textColor"
                      style={{ fontSize: "20px" }}
                    >
                      {data.INVDATE}
                    </p>
                  </div> */}
                </div>
              </div>
              <div className="mb-1 w-100 d-flex justify-content-end">
                {data.DELIVERED_DATE && (
                  <div className="mb-1 w-100 ">
                    <ul className="m-0 ps-4">
                      <li>
                        <p
                          className="m-0  rounded-5 ps-2 pe-2"
                          style={{
                            background: primary.value,
                            color: primaryFount.value,
                            fontSize: "9px",
                            width: "85px",
                            textWrap: "nowrap",
                          }}
                        >
                          {translateText(
                            currentLanguage.value,
                            "DeliveredDate"
                          )}
                        </p>
                        <p
                          className="form-label m-0 textColor"
                          style={{ fontSize: "12px" }}
                        >
                          {data.DELIVERED_DATE}
                        </p>
                      </li>
                    </ul>
                  </div>
                )}

                <div className=" d-flex align-items-end ">
                  <button
                    type="button"
                    className="btn btn-primary border pe-3 ps-3 w-100"
                    style={{
                      background: primary.value,
                      color: primaryFount.value,
                    }}
                    onClick={() => handleShow(data)}
                  >
                    {translateText(currentLanguage.value, "Tracking")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <></>
      )}

      {selectedOrder && (
        <Modal
          show={showModal}
          onHide={handleClose}
          centered
          dir={LanguageDirection.value}
        >
          <Modal.Header closeButton>
            <div className="mb-1 p-3 w-100  text-black">
              <div
                className={
                  LanguageDirection.value === "rtl"
                    ? "text-start d-flex w-100 m-0"
                    : "text-end  d-flex w-100 m-0"
                }
              >
                <ReceiptLongIcon
                  style={{ fontSize: "40px", marginRight: "10px" }}
                />
                <div className="  ">
                  <p className="m-0 " style={{ fontSize: "9px" }}>
                    {translateText(currentLanguage.value, "OrderNumber")}
                  </p>
                  <p
                    className="form-label  m-0 textColor"
                    style={{ fontSize: "20px" }}
                  >
                    {selectedOrder.INVNO}
                  </p>
                </div>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="progress-track">
              {OrderDetailsData.value ? (
                <>
                  <p
                    className="form-label  m-0 textColor p-0 m-0"
                    style={{ fontSize: "14px" }}
                  >
                    {translateText(currentLanguage.value, "orderItems")}
                  </p>
                  <hr className="mb-0" />
                  <table className="w-100 text-center">
                    <thead>
                      <tr className="border-bottom">
                      <th>{translateText(currentLanguage.value, "No")}</th>
                        <th>{translateText(currentLanguage.value, "ProductCode")}</th>
                        <th>{translateText(currentLanguage.value, "Quantity")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {OrderDetailsData.value.map((data, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.ARTCODE}</td>
                          <td>{data.INVQTY}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <hr className="m-0" />
                </>
              ) : (
                <></>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="progress-track w-100">
              <ul id="progressbar">
                <li
                  className={`step0 text-start ${selectedOrder.APPROVE}`}
                  id="step1"
                >
                  {translateText(currentLanguage.value, "Ordered")}
                </li>
                <li
                  className={`step0 text-center ${selectedOrder.PREPARED}`}
                  id="step2"
                >
                  {translateText(currentLanguage.value, "Prepared")}
                </li>
                <li
                  className={`step0 text-center ${selectedOrder.SHIPPED}`}
                  id="step3"
                >
                  {translateText(currentLanguage.value, "Shipped")}
                </li>
                <li
                  className={`step0 text-end ${selectedOrder.DELIVERED}`}
                  id="step4"
                >
                  {translateText(currentLanguage.value, "Delivered")}
                </li>
              </ul>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default SearchOrderCard;
